var map = {
	"./001-responsive.svg": 8322,
	"./Upload-Limit.svg": 5746,
	"./available-to-embed.svg": 4682,
	"./boost-your-exposure.svg": 4075,
	"./custom-domain.svg": 9071,
	"./desktop/boost-exposure.svg": 5123,
	"./desktop/custom-domain.svg": 3042,
	"./desktop/drag-drop.svg": 2982,
	"./desktop/embed.svg": 8091,
	"./desktop/hero.jpg": 582,
	"./desktop/no-limit.svg": 2466,
	"./desktop/responsive.svg": 1295,
	"./drag-drop-image.svg": 9923,
	"./full-features-data": 5877,
	"./full-features-data.json": 5877,
	"./mobile/hero.jpg": 1706,
	"./tablet/hero.jpg": 2958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1714;